/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import {
  NotificationTemplateService,
  Wealthlane_NotificationService_DTOs_NotificationTemplate_ExportNotificationTemplateDto,
} from '../../services/wealthlane-notification-services';

const usePostBulkExportNotificationTemplate = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<
  | Wealthlane_NotificationService_DTOs_NotificationTemplate_ExportNotificationTemplateDto
  | undefined,
  unknown,
  any,
  unknown
> => {
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        NotificationTemplateService.postApiNotificationApiAppNotificationTemplateExportNotificationTemplates(
          payload
        )
      );
    },
    {
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostBulkExportNotificationTemplate;
